<!--  -->
<template>
  <div class="page-bg">
    <div class="page">
      <div class="progress">
        <div class="bar"><p :style="{ width: newPercent + '%' }"></p></div>
        <div class="num">{{ cardVOSList.length - needCardNum }}/{{ cardVOSList.length }}</div>
      </div>
      <div class="card-info">
        <div class="card-box">
          <div class="emptyData" v-if="!activityId">
            <img
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/coll_qs.png"
              alt=""
            />
            <p>该活动已下架~</p>
          </div>
          <div class="card-img" v-for="(item, k) in cardVOSList" :key="k" @click="openCard(item,k)">
            <img :src="!item.cardCount ? defaultImg[k] : item.cardIcon" />
            <div class="num" v-if="item.cardCount > 1">{{ item.cardCount }}</div>
          </div>
        </div>
      </div>
      <div class="synthesis">
        <div class="txt">
          {{
            needCardNum
              ? `还差${needCardNum}张即可合成张宇定制版盲盒呦~`
              : `恭喜集卡成功～快去合成吧～`
          }}
        </div>
        <button @click="getSynthesis" :class="{ active: !needCardNum }"></button>
      </div>
      <div class="success-num">{{ peopleNum }}人已集齐卡片</div>
      <div class="foot">
        <div class="lottery-btn" @click="getDrawCard">
          剩余次数{{ activityUserInfo.remainingTimes || 0 }}
        </div>
        <div class="add-btn" @click="openTaskList"></div>
      </div>
      <div class="paper-card">
        <div class="box" @click="jumpCardChange">纸质版卡片兑换入口</div>
      </div>
      <div class="entrance">
        <img
          class="rule"
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/correction/rule-icon.png"
          @click="jumpRule"
        />
        <img
          class="record"
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/correction/record-icon.png"
          @click="jumpRecord"
        />
        <img
          class="prize"
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-words-mini/correction/prize-icon.png"
          @click="jumpPrize"
        />
      </div>
      <div class="prize-content">
        <img
          class="cardprizeImg"
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/cardprizeImg1.png"
          alt=""
        />
      </div>
      <div class="rule-content">
        <div class="title"></div>
        <div class="html" v-html="description"></div>
      </div>

      <!-- 抽到卡 -->
      <DrawCardSuccess
        ref="lotterySuccess"
        :lotteryRes="lotteryRes"
        :cardVOSList="cardVOSList"
        @continueLottry="continueLottry"
        :activityUserInfo="activityUserInfo"
      />
      <!-- 没有抽中卡 -->
      <DrawCardFail
        ref="lotteryFail"
        @continueLottry="continueLottry"
        :activityUserInfo="activityUserInfo"
      />
      <!-- 卡片站 -->
      <ShowCard ref="showCard" :cardInfo="currentCardInfo" />
      <!-- 合成卡片结果 -->
      <SynthesisCard ref="synthesis" :synthesisRes="synthesisRes" :activityId="activityId" />
      <!-- 任务列表 -->
      <TaskList ref="task" :taskList="taskList" :activityId="activityId" />
      <LotteryGif ref="lotteryGif" />
      <SynthesisGif ref="synthesisGif" />
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import { mapState } from 'vuex';
import loadJS from 'load-js';
import {
  reqActivityInfo,
  reqActivityUserInfo,
  reqActivityTask,
  reqActivitySynthesis,
  reqActivityLottery,
} from '@/api/collectCard/index';
import TaskList from './component/taskList.vue';
import ShowCard from './component/showCard.vue';
import DrawCardSuccess from './component/drawCardSuccess.vue';
import DrawCardFail from './component/drawCardFail.vue';
import SynthesisCard from './component/synthesisCard.vue';
import LotteryGif from './component/lotteryGif.vue';
import SynthesisGif from './component/synthesisGif.vue';
import { Dialog } from 'vant';

export default {
  components: {
    TaskList,
    ShowCard,
    DrawCardSuccess,
    SynthesisCard,
    DrawCardFail,
    LotteryGif,
    SynthesisGif,
  },
  data() {
    return {
      isApp: this.$root.$data.isApp,
      miniprogram: this.$root.$data.miniprogram,
      activityId: 1, // 活动ID
      cardVOSList: [], // 集卡信息
      activityUserInfo: {}, // 用户参与集卡的数据
      taskList: [], // 任务列表
      lotteryRes: '', // 抽卡结果
      synthesisRes: {}, //合成卡片结果
      basicInfo: {
        shareImg:
          'https://ark-test-cdn-images.iqihang.com/image/20240815/d83dd1ce1a8144f0be6667759dd39ea0.jpg',
      },
      peopleNum: 0,
      defaultImg: [
        'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/no-data1.png',
        'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/no-data2.png',
        'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/no-data3.png',
        'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/no-data4.png',
        'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/no-data5.png',
      ],
      taskIcon: {
        LOOK1: {
          btnTxt: '去浏览',
        },
        ORDER1: {
          btnTxt: '去看看',
        },
        BASIC1: {
          btnTxt: '去上传',
        },
        BASIC2: {
          btnTxt: '去下载',
        },
        BASIC3: {
          btnTxt: '去关注',
        },
        BASIC4: {
          btnTxt: '去邀请',
        },
      },
      currentCardInfo: {},
      needCardNum: 0,
      description: '',
    };
  },
  computed: {
    ...mapState(['userInfo']),
    newPercent() {
      const percent =
        ((this.cardVOSList?.length - this.needCardNum) / this.cardVOSList?.length) * 100;
      return percent > 100 ? 100 : percent;
    },
  },
  watch: {
    $route: {
      handler() {
        this.$router.go();
      },
      deep: true,
    },
  },
  methods: {
    // 查询活动基本信息
    async getActivityInfo() {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      const { data } = await reqActivityInfo('ZY');
      const { cardVOS, id, num, description } = data || {};
      console.log(id, 9988);
      this.activityId = id;
      this.cardVOSList = cardVOS || [];
      this.needCardNum = cardVOS?.length || 0;
      this.peopleNum = num || 0;
      this.description = description;
      if (!id) {
        this.$toast.clear();
        return;
      }
      this.getActivityUserInfo(id);
      this.getActivityTask(id);
    },
    // 查询用户参与活动信息
    async getActivityUserInfo(id) {
      if (!id) return;
      try {
        const { data } = await reqActivityUserInfo(id);
        const { userCardInfo } = data || {};
        this.cardVOSList.forEach((item) => {
          const res = userCardInfo?.find((ele) => ele?.cardCode === item?.cardCode) || {};
          Object.assign(item, { cardCount: res?.cardCount });
        });

        this.$toast.clear();
        const filterRes = this.cardVOSList.filter((ele) => !ele.cardCount);
        this.needCardNum = filterRes?.length;
        this.activityUserInfo = data || {};
      } catch (error) {
        this.$toast.clear();
      }
    },
    // 抽卡
    async getDrawCard() {
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      if (!this.activityUserInfo?.remainingTimes) {
        this.$toast('快去完成任务获取抽卡次数~');
        setTimeout(() => {
          this.openTaskList();
        }, 2000);
        return;
      }
      this.$refs.lotteryGif.changeShow();
      const { data, code, msg } = await reqActivityLottery(this.activityId);
      if (code) {
        this.$toast(msg);
        return;
      }
      setTimeout(() => {
        this.$refs.lotteryGif.changeShow();
        this.lotteryRes = data;
        if (Number(data)) {
          this.$refs.lotterySuccess.show = true;
        } else {
          this.$refs.lotteryFail.show = true;
        }

        this.getActivityUserInfo(this.activityId);
      }, 1500);
    },
    getSynthesis() {
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      if (this.needCardNum || !this.activityId) return;
      Dialog.confirm({
        title: '',
        message: '是否确认合成？',
      })
        .then(() => {
          this.toSynthesis();
        })
        .catch(() => {});
    },
    // 合成卡片
    async toSynthesis() {
      this.$refs.synthesisGif.changeShow();
      const { data, code, msg } = await reqActivitySynthesis(this.activityId);
      setTimeout(() => {
        if (code) {
          this.$refs.synthesisGif.changeShow();
          this.$toast(msg);
          return;
        }
        this.$refs.synthesisGif.changeShow();
        this.getActivityUserInfo(this.activityId);
        this.$refs.synthesis.show = true;
        this.synthesisRes = data;
      }, 1000);
    },
    // 查询任务列表
    async getActivityTask(id) {
      if (!id) return;
      const { data } = await reqActivityTask(id, this.isApp ? 3 : this.miniprogram ? 1 : 2);
      data?.forEach((item) => {
        const temp = this.taskIcon[item.taskType];
        Object.assign(item, { btnTxt: temp.btnTxt });
      });
      this.taskList = data || [];
    },

    async getLoginAfter() {
      await this.$root.getUserInfo();
      this.getActivityInfo();
    },
    // app 登录回掉
    getLogin(APPSESSION) {
      const ua = navigator.userAgent.toLowerCase();
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    // 去登录
    toLogin() {
      if (this.isApp) {
        const address = `${window.location.origin}/ark/collectCardIndex?cardActivityId=${this.activityId}`;
        this.$sendToApp('newLogin', { clientType: 30, address }, true);
      } else if (this.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if (searchParams) {
          const params = searchParams.split('&');
          const paramsMap = new Map();
          params.forEach((item) => {
            const [key, value] = item.split('=');
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
          }
          url = `${domain}?${query}cardActivityId=${this.activityId}`;
          console.log(url);
          const redirctUrl = encodeURIComponent(
            `/subPackages/detailWebView/index?url=${encodeURIComponent(url)}`,
          );
          const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
          wx.miniProgram.redirectTo({
            url: path,
          });
        }
      } else {
        const param = { redirect: '/collectCardIndex', ...this.$route.query };
        this.$router.push({ path: '/registrationLogin', query: param });
      }
    },
    // 任务列表
    openTaskList() {
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      this.$refs.task.changeShow();
    },
    // 活动规则
    jumpRule() {
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      this.$router.push({ path: '/cardRule', query: {} });
    },
    // 奖品
    jumpPrize() {
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      this.$router.push({ path: '/cardPrizeList', query: {} });
    },
    // 记录
    jumpRecord() {
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      this.$router.push({ path: '/cardRecord', query: { cardActiveId: this.activityId } });
    },
    // 纸质版退换
    jumpCardChange() {
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      this.$router.push({ path: '/cardExchange', query: {} });
    },
    // 继续抽卡
    continueLottry() {
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      this.getDrawCard();
    },
    openCard(item,i) {
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      if(!item.cardCount){
      Object.assign(item,{cardIcon:this.defaultImg[i]})

      }
      this.currentCardInfo = item;
      this.$refs.showCard.show = true;
    },
    createImg() {
      loadJS([
        {
          async: false,
          url: 'https://image-prod.iqihang.com/public/js/qrcode.min.js',
        },
      ]).then(() => {});
    },
    init(mode) {
      this.getActivityInfo();
    },
  },
  created() {},
  mounted() {
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
      window['iqhApp2jsBridge.triggerSC'].reload = this.init;
    }, 100);
    document.title = '集卡活动';
    this.getActivityInfo();
    this.createImg();
    console.log('mounted-----');

    document.addEventListener('visibilitychange', () => {
      console.log('visibilitychange-----');
      if (document.visibilityState === 'visible') {
        console.log('visible-----');
        // if(sessionStorage.getItem('cardPhoto') || $root.$data.isApp){
        //   sessionStorage.removeItem('cardPhoto')
        //   console.log("不让刷新")
        // }else{
        //  // 在这里执行你需要的刷新操作
        //    console.log("我刷新了")
        //     location.reload();
        // }
        this.getActivityInfo();
        this.createImg();
      }
    });
    window.addEventListener('pageshow', (e) => {
      console.log('pageshow-----');
      if (e.persisted) {
        console.log('e.persisted-----');
        this.getActivityInfo();
        this.createImg();
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.page-bg {
  background: #8e92ec;
}
.page {
  width: 100%;
  min-height: 100vh;
  padding-top: 277px;
  background: #8e92ec;
  background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/home-bg.png')
    no-repeat;
  background-size: 100%;
  .progress {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 500px;
    height: 77px;
    margin: 0 auto;
    padding: 0 21px;
    background-image: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/home-progress.png');
    background-size: 100%;
    .bar {
      width: 230px;
      height: 26px;
      background: #fff;
      border-radius: 13px;
      p {
        height: 26px;
        background: #5d6dff;
        border-radius: 13px;
      }
    }
    .num {
      padding-left: 13px;
      color: #5d6dff;
      font-weight: 500;
      font-size: 36px;
    }
  }
  .card-info {
    margin-top: 125px;
    padding: 0 59px;
    // min-height: 650px;
    .emptyData {
      display: flex;
      flex-wrap: wrap;
      align-content: center;
      align-items: center;
      margin: 0 auto 0;
      img {
        display: block;
        width: 370px;
        height: 272px;
        margin: 0 auto 0;
      }
      p {
        width: 100%;
        height: 31px;
        color: #000;
        font-weight: 400;
        font-size: 26px;
        line-height: 31px;
        text-align: center;
      }
    }
    .card-box {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      min-height: 565px;
      .card-img:nth-child(3n) {
        margin-right: 0;
      }
      .card-img {
        position: relative;
        margin-right: 10px;
        margin-bottom: 5px;
        border-radius: 20px;
        img {
          width: 204px;
          height: 272px;
          border-radius: 20px;
        }
        .num {
          position: absolute;
          top: 0;
          right: 0;
          width: 59px;
          height: 46px;
          color: #ff5823;
          font-weight: bold;
          font-size: 24px;
          line-height: 46px;
          text-align: center;
          background: #ffe288;
          border-radius: 0 20px 0 20px;
        }
      }
    }
  }
  .synthesis {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    width: 633px;
    height: 74px;
    margin: 22px auto 0;
    padding: 0 6px 0 34px;
    background: #5d6dff;
    border-radius: 20px;
    .txt {
      color: #fff;
      font-weight: 500;
      font-size: 26px;
    }
    button.active {
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/merge-btn1.png');
      background-size: 100%;
    }
    button {
      width: 133px;
      height: 62px;
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/merge-btn2.png');
      background-size: 100%;
      border: none;
      outline: none;
    }
  }
  .success-num {
    margin: 11px auto;
    color: #5d6dff;
    font-weight: 500;
    font-size: 26px;
    text-align: center;
  }
  .foot {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-top: 10px;
    border-bottom: 13px solid #e8eafa;
    .lottery-btn {
      width: 368px;
      height: 128px;
      padding-top: 63px;
      color: #fff;
      font-weight: 400;
      font-size: 21px;
      text-align: center;
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/lottery-btn.png');
      background-size: 100%;
    }
    .add-btn {
      width: 140px;
      height: 99px;
      margin: 0 21px 0 30px;
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/add-btn.png');
      background-size: 100%;
    }
  }
  .paper-card {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 110px;
    background: #8e92ec;
    .box {
      width: 450px;
      height: 60px;
      color: #fff;
      font-weight: 500;
      font-size: 30px;
      line-height: 60px;
      text-align: center;
      background: rgba($color: #000, $alpha: 0.5);
      border-radius: 30px;
    }
  }
  .entrance {
    .rule {
      position: fixed;
      top: 144px;
      right: 0;
     z-index: 3;
      width: 72px;
      height: 56px;
    }
    .record {
      position: fixed;
      top: 220px;
      right: 0;
     z-index: 3;
      width: 72px;
      height: 56px;
    }
    .prize {
      position: fixed;
      top: 850px;
      right: 0;
      z-index: 3;
      width: 92px;
      height: 110px;
    }
  }
  .prize-content {
    padding: 15px 36px 0 36px;
    img {
      display: block;
      margin: 0 auto;
    }
    .cardprizeImg {
      width: 630px;
    }
  }
  .rule-content {
    width: 100%;
    margin-top: 40px;
    padding: 0 36px;
    .title {
      position: relative;
      z-index: 2;
      width: 470px;
      height: 94px;
      margin: 0 auto;
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/rule-title.png')
        no-repeat;
      background-size: 100%;
    }
    .html {
      position: relative;
      top: -45px;
      z-index: 1;
      width: 630px;
      min-height: 910px;
      margin: 0 auto;
      padding:60px 26px 26px  26px;
      background: linear-gradient(180deg, #fcebfe 0%, #e2f5fe 100%);
      border: 10px solid #766BE5;
      border-radius: 40px;
      // border-image: linear-gradient(180deg, rgba(118, 107, 229, 1), rgba(127, 166, 241, 1)) 10 10;
      ::v-deep img {
        width: 100%;
      }

      ::v-deep p {
        color: #333;
        font-weight: 400;
        font-size: 25px;
        line-height: 36px;
        word-wrap: break-word; /* IE */
        overflow-wrap: break-word; /* 其他浏览器 */
      }
    }
  }
}
</style>
